var map = {
	"./drdoctor/img/icons/new_terms_new_icon.png": 657,
	"./freedoctor/img/icons/new_terms_new_icon.png": 658,
	"./freelegal/img/icons/new_terms_new_icon.png": 659,
	"./legalchief/img/icons/new_terms_new_icon.png": 660,
	"./medi4u/img/icons/new_terms_new_icon.png": 661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 656;